import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const BloodtypeIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"bloodtype"} ref={ref}/>
});

BloodtypeIcon.displayName = "BloodtypeIcon";
